import type { Action } from "../actions.types";
import { isActionCompleted } from "./isActionCompleted";

/**
 * Sort actions by status (completed last) then by due date (ascending).
 * Actions without a due date are sorted to the end within each status group.
 */
export function sortActionsByStatusAndDueDate(actions: Action[]): Action[] {
  return [...actions].sort((a, b) => {
    const aCompleted = isActionCompleted(a);
    const bCompleted = isActionCompleted(b);

    // Sort by completion status first (completed last)
    if (aCompleted !== bCompleted) {
      return aCompleted ? 1 : -1;
    }

    // Within the same completion status, sort by due_date
    const aDueDate = a.due_date;
    const bDueDate = b.due_date;

    // Actions without due_date go to the end within their status group
    if (!aDueDate && !bDueDate) return 0;
    if (!aDueDate) return 1;
    if (!bDueDate) return -1;

    // Sort by due_date ascending
    return new Date(aDueDate).getTime() - new Date(bDueDate).getTime();
  });
}
